import $axios from "../../../core/rest/axios";
export default class CreateService {
    create(data) {
        // Note: no liferay /o/rest, no /servlet/proxy
        return $axios.post("/kultura-brno/rest/newsletter", data);
    }
}
